import MerchantAdminApi from '@/api/merchant-admin'

const state = {
}

const mutations = {
}

const actions = {
  async list ({ commit }) {
    const result = await MerchantAdminApi.list()
    return result
  },
  async insert ({ commit }, data) {
    const result = await MerchantAdminApi.insert(data)
    return result
  },
  async update ({ commit }, data) {
    const result = await MerchantAdminApi.update(data)
    return result
  },
  async enable ({ commit }, id) {
    const result = await MerchantAdminApi.enable(id)
    return result
  },
  async disable ({ commit }, id) {
    const result = await MerchantAdminApi.disable(id)
    return result
  },
  async resetPassword ({ commit }, data) {
    const result = await MerchantAdminApi.resetPassword(data.id, data.password)
    return result
  },
  async getAdminSettings ({ commit }, id) {
    const result = await MerchantAdminApi.getAdminSettings(id)
    return result
  },
  async getMerchantDet ({ commit }, id) {
    const result = await MerchantAdminApi.getMerchantDet(id)
    return result
  },
  async setAdminSettingValue ({ commit }, data) {
    const result = await MerchantAdminApi.setAdminSettingValue(data)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-admin.js